import { Group, Stack, Text, Tooltip } from '@mantine/core';
import { useState } from 'react';
import { useLocation, useHistory, matchPath } from "react-router-dom";
import RestrictedMenuMessageModal from '../neoverv/components/Module/General/CustomModal/RestrictedMenuMessageModal';

import Icon from './Icon';

// Single menu item
export const MainMenuItem = ({ icon, route, children, href, target, color=null, alwaysColored=false, ...props }) => {
  const [ hovered, setHovered ] = useState(false);
  const [ openRestrictedMenuMessage, setOpenRestrictedMenuMessage ] = useState(false);
  const history = useHistory();
  const { pathname } = useLocation();

  const handleNavigate = (event) => {
    if(props.blockUsersFromUsingApp === false){
      event.preventDefault();

      // Items that act instead of navigating (e.g. hellohousing KI, Hilfe)
      // pass their own onClick; it runs from here so it stays behind the same
      // gate as the routed items.
      if (props.onClick) {
        props.onClick(event);
      }

      if (route) {
        history.push(route);
        history.replace(route);
      }
  
      if (href) {
        window.open(href);
      }
    }else{
      if(props?.accountData?.invoicesStatus === 'FAILED'){
        props.history.push('/profile/paymentDetails');
        // document.getElementById('open-settle-invoices-modal')?.click();
      }else if(props?.accountData?.accountPaymentStatus !== 'PAYMENT_ERROR'){
        if(props.getSubscriptionsSuccess){
          setOpenRestrictedMenuMessage(true);
        }
      }
    }
  }

  const pathMatches = () => matchPath(pathname, { path: route });
  const isColored = alwaysColored || pathMatches() || hovered;

  return (
    <>
      <Tooltip label={(props?.accountData?.accountPaymentStatus === 'PAYMENT_ERROR' || props?.accountData?.invoicesStatus === 'FAILED') ? 'Der Zugriff auf diese Funktion ist derzeit nicht möglich.' : props.hasTested ? 'Wählen Sie ein Abonnement, um auf diese Funktion zuzugreifen.' : 'Bitte starten Sie den Testzeitraum, um auf diese Funktion zuzugreifen.'} disabled={props.blockUsersFromUsingApp === false}>
        <Group 
          style={{
            cursor: props.blockUsersFromUsingApp ? 'not-allowed' : 'pointer',
            position: 'relative',
            paddingTop: 5,
            paddingBottom: 5,
            paddingLeft: 20
          }}
          onMouseOver={() => props.blockUsersFromUsingApp === false && setHovered(true)}
          onMouseOut={() => setHovered(false)}
          {...props}
          onClick={handleNavigate}
        >
          {pathMatches() && (
            <div 
              style={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: -3,
                width: 6,
                borderRadius: 3,
                backgroundColor: 'rgba(86, 85, 255, 1.00)'
              }}
            />
          )}
          {icon && <Icon name={icon} color={isColored ? color ? color : 'rgba(86, 85, 255, 1.00)' : 'rgba(154, 154, 181, 1.00)'} />}
          <Text className={route === '/documents' ? 'main-menu-documents-text tooltips' : route === '/messaging' ? 'main-menu-messaging-text tooltips' : children === 'Hilfe' ? 'main-menu-help-text tooltips' : children === 'Konto' && 'main-menu-account-text tooltips'} style={{ color: isColored ? color ? color : 'rgba(86, 85, 255, 1.00)' : 'rgba(154, 154, 181, 1.00)' }}>{children}</Text>
        </Group>
      </Tooltip>
      {openRestrictedMenuMessage &&
      <RestrictedMenuMessageModal
      open={openRestrictedMenuMessage}
      toggle={()=> setOpenRestrictedMenuMessage(false)}
      history={props.history}
      />}
    </>
  )
}

// Main app menu
const MainMenu = (props) => {
  return (
    <Stack gap={6}>
      <MainMenuItem icon="dashboard" getSubscriptionsSuccess={props.getSubscriptionsSuccess} hasTested={props.hasTested} accountData={props.accountData} history={props.history} route="/dashboard" blockUsersFromUsingApp={false}>Übersicht</MainMenuItem>
      <MainMenuItem icon="home" getSubscriptionsSuccess={props.getSubscriptionsSuccess} hasTested={props.hasTested} accountData={props.accountData} history={props.history} route="/property" blockUsersFromUsingApp={props.blockUsersFromUsingApp}>Immobilie</MainMenuItem>
      {/* <MainMenuItem icon="users" getSubscriptionsSuccess={props.getSubscriptionsSuccess} hasTested={props.hasTested} accountData={props.accountData} history={props.history} route="/user" blockUsersFromUsingApp={props.blockUsersFromUsingApp}>{props?.propertySelected?.isWegModeActive ? 'Mieter / Eigentümer' : 'Mieter'}</MainMenuItem> */}
      <MainMenuItem icon="users" getSubscriptionsSuccess={props.getSubscriptionsSuccess} hasTested={props.hasTested} accountData={props.accountData} history={props.history} route="/user" blockUsersFromUsingApp={props.blockUsersFromUsingApp}>{'Mieter'}</MainMenuItem>
      <MainMenuItem icon="receipt" getSubscriptionsSuccess={props.getSubscriptionsSuccess} hasTested={props.hasTested} accountData={props.accountData} history={props.history} route="/accounting" blockUsersFromUsingApp={props.blockUsersFromUsingApp}>Buchhaltung</MainMenuItem>
      <MainMenuItem icon="meter" getSubscriptionsSuccess={props.getSubscriptionsSuccess} hasTested={props.hasTested} accountData={props.accountData} history={props.history} route="/meter" blockUsersFromUsingApp={props.blockUsersFromUsingApp}>Ablesungen</MainMenuItem>
      <MainMenuItem icon="tap" getSubscriptionsSuccess={props.getSubscriptionsSuccess} hasTested={props.hasTested} accountData={props.accountData} history={props.history} route="/utility-billing" blockUsersFromUsingApp={props.blockUsersFromUsingApp}>Betriebskosten</MainMenuItem>
      <MainMenuItem icon="messenger" getSubscriptionsSuccess={props.getSubscriptionsSuccess} hasTested={props.hasTested} accountData={props.accountData} history={props.history} route="/messaging" blockUsersFromUsingApp={props.blockUsersFromUsingApp}>Nachrichten</MainMenuItem>
      <MainMenuItem icon="documents" getSubscriptionsSuccess={props.getSubscriptionsSuccess} hasTested={props.hasTested} accountData={props.accountData} history={props.history} route="/documents" blockUsersFromUsingApp={props.blockUsersFromUsingApp}>Dokumente</MainMenuItem>
      <MainMenuItem icon="tenantPortal" getSubscriptionsSuccess={props.getSubscriptionsSuccess} hasTested={props.hasTested} accountData={props.accountData} history={props.history} route="/tenantPortal" blockUsersFromUsingApp={props.blockUsersFromUsingApp}>Mieterportal</MainMenuItem>
    </Stack>
  )
}

export default MainMenu